module.exports = __webpack_public_path__ + "assets/AMinPerimeter.49f132cb17f4b3d01a93eaae6f16cfb3.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/AMinPerimeter.gmt
// module id = 886
// module chunks = 0